module.exports = __webpack_public_path__ + "media/images/gift-thanks-modal-bg-candy-e710ff9b5563ec918b322bd22c065040.png";